import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const AccessModalSpreadPermissions = ({
  spreadPermissions,
  spreadPermissionsAlways,
  spreadPermissionsCollections,
  collectionsCount,
  handleChangeSpreadPermissions,
  handleChangeSpreadPermissionsAlways,
  handleChangeSpreadPermissionsCollections,
}) => {
  const intl = useIntl();

  return (
    <div className="access-spread">
      <Form className="access-spread-form">
        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              name="spread-permissions"
              value={true}
              checked={spreadPermissions}
              onChange={handleChangeSpreadPermissions}
            />
            {' '}
            {intl.formatMessage({
              defaultMessage: `Give users and Teams access to all files inside 
                {collectionsCount, plural, one {this Collection} other {these Collections}}`,
            }, { collectionsCount })}
          </Label>
        </FormGroup>
        {spreadPermissions && (
          <FormGroup>
            <Label>
              <Input
                type="select"
                className="custom-select"
                name="spread-permissions-always"
                defaultValue={spreadPermissionsAlways}
                onChange={handleChangeSpreadPermissionsAlways}
              >
                <option value="false">{intl.formatMessage({ defaultMessage: 'only current files' })}</option>
                <option value="true">{intl.formatMessage({ defaultMessage: 'current and future files' })}</option>
              </Input>
            </Label>
          </FormGroup>
        )}
        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              name="spread-permissions-collections"
              value={true}
              checked={spreadPermissionsCollections}
              onChange={handleChangeSpreadPermissionsCollections}
            />
            {' '}
            {intl.formatMessage({
              defaultMessage: `Add users and Teams to all sub-Collections inside 
                {collectionsCount, plural, one {this Collection} other {these Collections}}`,
            }, { collectionsCount })}
          </Label>
        </FormGroup>
      </Form>
    </div>
  );
};

AccessModalSpreadPermissions.propTypes = {
  spreadPermissions: PropTypes.bool.isRequired,
  spreadPermissionsAlways: PropTypes.bool.isRequired,
  spreadPermissionsCollections: PropTypes.bool.isRequired,
  collectionsCount: PropTypes.number.isRequired,
  handleChangeSpreadPermissions: PropTypes.func.isRequired,
  handleChangeSpreadPermissionsAlways: PropTypes.func.isRequired,
  handleChangeSpreadPermissionsCollections: PropTypes.func.isRequired,
};

export default AccessModalSpreadPermissions;
